import moment from "moment-timezone";

export function convertTime(dateTime, fromTimezone, toTimezone, format = "YYYY-MM-DD hh:mm A") {
    if ([dateTime, fromTimezone, toTimezone].some(v => !v || ["NULL", "UNDEFINED"].includes(String(v).trim().toUpperCase()))) {
        return null;
    }

    const dateTimeStr = typeof dateTime === 'string' ? dateTime.replaceAll("Z", "") : dateTime;

    return moment
        .tz(dateTimeStr, fromTimezone)
        .tz(toTimezone)
        .format(format);
}